import React, { useContext, useState, useEffect, useRef } from 'react';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { Body, Header, Main } from '../../NecttosComp/Layout/Layout';
import Button from '../../NecttosComp/Button/Button';
import { NecttosContext } from '../../context/NecttosContext';
import Instruction from '../../Documentation/Instruction';

const emojiMap = {
  enquiriesReceived: '📩',
  applicationsInitiated: '📝',
  pendingApplicationswithFeesPaid: '💰',
  completedApplications: '✅',
  courseWiseRankList: '📊',
  allotmentList: '📋',
  seatReservationDetails: '🪑',
  applicationForm: '🗂️',
  departmentVerfication: '🏢',
  nodalVerification: '👔',
  collegeFundCollection: '🏦',
  principalVerification: '🎓',
  officeVerification: '🏤',
  grandVerification: '🌟',
  govermentFeeCollection: '💵',
  universityUploads: '🎓',
};

function Controller({ keyData, onClose }) {
  const { collegeId, college, setCollege } = useContext(NecttosContext); // Added setCollege

  const [state, setState] = useState({
    ...(college?.verificationWindows),
    giveAdmissionNumberval:
      'When ' + (college?.verificationWindows?.giveAdmissionNumber || '') + ' Verification Process Completed',
  });

  const [message, setMessage] = useState(false);
  const boxRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const [maxHeight, setMaxHeight] = useState(0);

  // Rehydrate state from localStorage if present
  useEffect(() => {
    const saved = localStorage.getItem('controller_state');
    if (saved) {
      setState(JSON.parse(saved));
    }
  }, []);

  useEffect(() => {
    function updateMaxHeight() {
      const heights = boxRefs.map((ref) => ref.current?.offsetHeight || 0);
      setMaxHeight(Math.max(...heights));
    }
    updateMaxHeight();
    window.addEventListener('resize', updateMaxHeight);
    return () => window.removeEventListener('resize', updateMaxHeight);
  }, []);

  useEffect(() => {
    const fetchVerificationWindows = async () => {
      try {
        const instance = await getAxiosTokenInstance();
        const res = await instance.get('/college/admissionProcess2/controller', {
          params: { collegeId },
        });

        if (res.data.statusCode !== 200) {
          throw new Error(res.data.message || 'Failed to load data');
        }

        const verificationWindows = res.data.verificationWindows || {};
        setState({
          ...verificationWindows,
          giveAdmissionNumberval:
            'When ' + (verificationWindows?.giveAdmissionNumber || '') + ' Verification Process Completed',
        });
      } catch (error) {
        console.error('Error loading verification window data:', error);
      }
    };

    fetchVerificationWindows();
  }, [collegeId]);

  // Persist to localStorage
  useEffect(() => {
    localStorage.setItem('controller_state', JSON.stringify(state));
  }, [state]);

  const handleProceed = async () => {
    try {
      let data = {
        collegeId,
        ...state,
      };
      const instance = await getAxiosTokenInstance();
      let resp = await instance.post('/college/admissionProcess/controller', data);
      if (resp.data.statusCode !== 200) {
        throw new Error(resp.data.message || 'API Error');
      } else {
        // Update context here
        setCollege((prevCollege) => ({
          ...prevCollege,
          verificationWindows: { ...state },
        }));
        localStorage.removeItem('controller_state'); // clear saved state after successful save
        onClose();
      }
    } catch (error) {
      message.error(error?.response?.data?.message || error?.message || 'API Error');
    }
  };

  const handleCancel = () => {
    onClose();
  };

  const admissionNumberCreation = [
    { _id: 'principal', value: 'When Principal Verification Completed' },
    { _id: 'nodal', value: 'When Nodal Verification Completed' },
    { _id: 'department', value: 'When Department Verification Completed' },
    { _id: 'office', value: 'When Office Verification Completed' },
    { _id: 'fees', value: 'When Government Fees Collected' },
  ];

  const processOfAdmissions = [
    { keyData: 'enquiriesReceived', title: 'Enquiries Received' },
    { keyData: 'applicationsInitiated', title: 'Applications Initiated' },
    { keyData: 'pendingApplicationswithFeesPaid', title: 'Pending Applications with Fees Paid' },
    { keyData: 'completedApplications', title: 'Completed Applications' },
    { keyData: 'courseWiseRankList', title: 'Course Wise Rank List' },
    { keyData: 'allotmentList', title: 'Allotment List' },
    { keyData: 'seatReservationDetails', title: 'Seat Reservation Details' },
    { keyData: 'applicationForm', title: 'Application Form' },
    { keyData: 'departmentVerfication', title: 'Department Verification' },
    {
      keyData: 'nodalVerification',
      title:
        collegeId === 'COL-D6DE25F23FF5-40A6-9E76-4A2AF63D1B5F'
          ? 'Department Senior Verification'
          : 'Nodal Verification',
    },
    { keyData: 'collegeFundCollection', title: 'PTA Fund Collection' },
    { keyData: 'principalVerification', title: 'Principal Verification' },
    { keyData: 'officeVerification', title: 'Office Verification' },
    { keyData: 'grandVerification', title: 'Grand Verification' },
    { keyData: 'govermentFeeCollection', title: 'Government Fees Collection' },
    { keyData: 'universityUploads', title: 'University Uploads Verification' },
  ];

  const applicationItems = processOfAdmissions.slice(0, 4);
  const allotmentItems = processOfAdmissions.slice(4, 8);
  const verificationItems = processOfAdmissions.slice(8);

  const Input2 = ({
    type,
    fieldName,
    returnKey,
    state,
    setState,
    options,
    optionDisplay,
    optionKey,
    className,
    valueShowKey = null,
    didntShowKey = false,
  }) => {
    if (type === 'checkbox') {
      return (
        <input
          type="checkbox"
          className="h-5 w-5 rounded-md border-gray-300 focus:ring-blue-500"
          checked={state[returnKey] || false}
          onChange={(e) => setState({ ...state, [returnKey]: e.target.checked })}
        />
      );
    } else if (type === 'radio') {
      return (
        <fieldset className="space-y-3">
          <legend className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            {fieldName}
          </legend>
          <div className="flex flex-col gap-2">
            {options.map((option, idx) => (
              <label
                key={idx}
                className="inline-flex items-center cursor-pointer text-gray-900 dark:text-gray-200"
              >
                <input
                  type="radio"
                  name={returnKey}
                  value={option[optionKey]}
                  checked={state[returnKey] === option[optionKey]}
                  onChange={() => setState({ ...state, [returnKey]: option[optionKey] })}
                  className="form-radio h-5 w-5 text-blue-600"
                />
                <span className="ml-2">{option[optionDisplay]}</span>
              </label>
            ))}
          </div>
        </fieldset>
      );
    }
    return null;
  };

  return (
    <Main width="100%" height="100%" title="Admission Controller">
      <Header>

<div></div>
        <div className='flex justify-end'>
          <Button type='save' onClick={handleProceed}>Save</Button>
          <Instruction keyId={'controller'} />
          <Button type='close' onClick={onClose}>
            close
          </Button>
        </div>
      </Header>
      <Body>
        <div className="flex flex-col md:flex-row justify-center items-start gap-6 p-5 bg-neutral-100 dark:bg-neutral-800 rounded-b-lg shadow-md w-full">
          {[applicationItems, allotmentItems, verificationItems].map((items, idx) => (
            <section
              key={idx}
              ref={boxRefs[idx]}
              style={{ minHeight: maxHeight }}
              className="w-full md:w-1/4 rounded-lg p-5 shadow-md flex flex-col bg-slate-100 dark:bg-neutral-700"
            >
              <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-6">
                {['Application Process', 'Allotment Process', 'Verification Process'][idx]}
              </h2>

              <table className="w-full border-collapse flex-grow">
                <tbody>
                  {items.map(({ keyData, title }) => {
                    const emoji = emojiMap[keyData] || '';
                    return (
                      <tr
                        key={keyData}
                        className="cursor-pointer hover:bg-blue-100 dark:hover:bg-neutral-600 rounded-md"
                      >
                        <td className="py-2 pl-2 align-middle w-12">
                          <Input2
                            type="checkbox"
                            returnKey={keyData}
                            state={state}
                            setState={setState}
                            className="w-5 h-5"
                            fieldName={''}
                          />
                        </td>
                        <td className="align-middle">
                          <div className="flex items-center gap-3 select-none py-2">
                            <span
                              className="text-white rounded-full w-8 h-8 flex justify-center items-center text-lg flex-shrink-0 bg-blue-600 dark:bg-blue-400"
                              aria-label="icon"
                            >
                              {emoji}
                            </span>
                            <span className="text-gray-800 dark:text-gray-200">{title}</span>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </section>
          ))}

          <section
            ref={boxRefs[3]}
            style={{ minHeight: maxHeight }}
            className="w-full md:w-1/4 rounded-lg p-5 shadow-md flex flex-col bg-slate-100 dark:bg-neutral-700"
          >
            <Input2
              type="radio"
              fieldName="When admission number is provided, select from the options below:"
              returnKey="_id"
              didntShowKey
              state={state}
              setState={setState}
              options={admissionNumberCreation}
              optionDisplay="value"
              optionKey="value"
              className="w-full text-gray-900 dark:text-gray-300"
              valueShowKey=" "
            />
          </section>
        </div>
      </Body>
    </Main>
  );
}

export default Controller;